var SCM = SCM || {};

(function (SolrSearch, $, undefined) {
    SolrSearch.ExpandedCollectionSites = [];
    // ----
    // private variables and functions
    // ----
    var bodyVar = $('body'),
        hfSolrJournalID = $('#hfSolrJournalID'),
        hfParentSiteName = $('#hfParentSiteName').val(),
        hfGlobalSearchSiteURL = $('#hfGlobalSearchSiteURL').val(),
        hfjournalSiteScope = $('#hfJournalSiteScope').val(),
        hfparentSiteScope = $('#hfParentSiteScope').val(),
        searchSiteID = $('#hfSiteID').val(),
        hfParentSiteURL = $('#hfParentSiteUrl').val(),
        hfparentSiteID = $('#hfParentSiteID').val(),
        siteUrl = $('#hfSiteURL').val(),
        hfdefaultSearchURL = $('#hfDefaultSearchURL').val(),
        defaultAdvancedSearchUrl = $('#hfDefaultAdvancedSearchUrl').val(),
        hfIssueSearch = $('#hfIssueSearch').val(),
        hfIssueSiteScope = $('#hfIssueSiteScope').val(),
        hfCurrentBookSearch = $('#hfCurrentBookSearch').val(),
        hfCurrentBookScope = $('#hfCurrentBookScope').val(),
        hfBookSiteScope = $('#hfBookSiteScope').val(),
        hfSeriesScope = $('#hfSeriesScope').val(),
        hfUmbrellaScope = $('#hfUmbrellaScope').val(),
        hfUmbrellaSiteUrl = $('#hfUmbrellaSiteUrl').val(),
        hfUmbrellaSiteId = $('#hfUmbrellaSiteId').val(),
        hfTaggedCollectionScope = $('#hfTaggedCollectionScope').val(),
        hfApplyLatestEditionSearchFacet = $('#hfApplyLatestEditionSearchFacet').val(),
        hfIsLatestBookEdition = $('#hfIsLatestBookEdition').val(),
        searchAcrossOA = '',
        queryText = '',
        currentSearchScope;

    var selectedSearchFilter = $('.navbar-search-filter :selected');
    if (selectedSearchFilter.length) {
        currentSearchScope = selectedSearchFilter.val();
    }
    else { // default to an umbrella search
        currentSearchScope = hfUmbrellaScope;
    }

    $('.navbar-search-filter, .mobile-navbar-search-filter').on('change', function () {
        currentSearchScope = $(this).val();
        var selected = $(':selected', this);
        searchAcrossOA = (selected.closest('optgroup').attr('class'));
        setAdvancedSearchLinkToCurrentSearchScope();
    });

    function setAdvancedSearchLinkToCurrentSearchScope() /* void */ {
        if (currentSearchScope === hfparentSiteScope) {
            // Parent site
            $('.js-advanced-search').attr('href', getBaseUrl(hfParentSiteURL) + '/' + getSearchUrl({ baseUrl: defaultAdvancedSearchUrl }));
        } else if (currentSearchScope === hfBookSiteScope) {
            // Books site
            $('.js-advanced-search').attr('href', getBaseUrl() + '/books/' + getSearchUrl({ baseUrl: defaultAdvancedSearchUrl }));
        } else if (currentSearchScope === hfjournalSiteScope) {
            // Journals site
            $('.js-advanced-search').attr('href', getBaseUrl() + '/journals/' + getSearchUrl({ baseUrl: defaultAdvancedSearchUrl, passAllJournals: true }));
        } else if (currentSearchScope === hfCurrentBookScope) {
            // Curremt book
            $('.js-advanced-search').attr('href', getBaseUrl(siteUrl) + '/' + getSearchUrl({ baseUrl: defaultAdvancedSearchUrl, searchSiteId: hfparentSiteID, currentBookSearch: true }));
        } else if (currentSearchScope === hfUmbrellaScope) {
            // Umbrella
            $('.js-advanced-search').attr('href', getBaseUrl(hfUmbrellaSiteUrl) + '/' + getSearchUrl({ baseUrl: defaultAdvancedSearchUrl, searchSiteId: hfUmbrellaSiteId }));
        } else if (currentSearchScope.startsWith(hfTaggedCollectionScope)) {
            // Tagged Collection search
            $('.js-advanced-search').attr('href', getBaseUrl(siteUrl) + '/' + getSearchUrl({ baseUrl: defaultAdvancedSearchUrl, searchSiteId: searchSiteID, taggedCollection: currentSearchScope }));
        } else if (currentSearchScope.startsWith(hfSeriesScope)) {
            // Series Taxonomy search
            $('.js-advanced-search').attr('href', getBaseUrl(siteUrl) + '/' + getSearchUrl({ baseUrl: defaultAdvancedSearchUrl, searchSiteId: searchSiteID, series: currentSearchScope }));
        } else if (searchAcrossOA) {
            // Oxford Taxonomy umbrella search
            $('.js-advanced-search').attr('href', getBaseUrl(hfUmbrellaSiteUrl) + '/' + getSearchUrl({ baseUrl: defaultAdvancedSearchUrl, searchSiteId: searchSiteID, series: currentSearchScope }));
        } else if (currentSearchScope !== '') {
            // Taxonomy search
            $('.js-advanced-search').attr('href', getBaseUrl(siteUrl) + '/' + getSearchUrl({ baseUrl: defaultAdvancedSearchUrl, searchSiteId: searchSiteID, taxonomy: currentSearchScope }));
        } else {
            // Current site
            $('.js-advanced-search').attr('href', getBaseUrl(siteUrl) + '/' + getSearchUrl({ baseUrl: defaultAdvancedSearchUrl, searchSiteId : searchSiteID }));
        }
    }

    function getBaseUrl(/*string?*/ override) /* -> string */ {
        if (!isNullOrEmpty(override)) {
            return getUrlProtocol() + override;
        } else {
            return getUrlProtocol() + window.location.hostname;
        }
    }

    function getUrlProtocol() /* -> string */ {
        return window.location.protocol + '//';
    }

    // Used in both iconClickSearch() and keydownSearch()
    var testSearchInput = function (inputToTest, scope) {
        var autoSuggestRunning = false;

        if (hfParentSiteName !== '') {
            doSolrSearch(inputToTest, scope);
        } else {
            //search term should not be blank
            if ($.trim(inputToTest) === '' || inputToTest === null || inputToTest === 'Search OUP') {
                alert('Please enter a term to search: ');
                return false;
            } else if (!autoSuggestRunning && inputToTest) {
                doSolrSearch(inputToTest, scope);
                return true;
            } else {
                console.error('Search failed');
                return false;
            }
        }

    }; // END: testSearchInput()

    var doKeywordsTopicsSearch = function (keyword) {
        // make sure keyword is wrapped in quotes
        if (keyword[0] !== '"' && keyword[keyword.length - 1] !== '"') {
            keyword = '"' + keyword + '"';
        }

        var defaultQueryBuilder = 'page=1&qb={Keywords1:' 
            + encodeURIComponent(keyword)
            + '}&SearchSourceType=1';

        var customQueryBuilder = 'cqb=[{%22terms%22:[{%22filter%22:%22Keywords%22,%22input%22:'
            + encodeURIComponent(keyword)
            + '}]}]&qb={%22Keywords1%22:'
            + encodeURIComponent(keyword)
            + '}&page=1&searchType=advanced&adv=true';

        var rawSearchUrl = $('.js-custom-queryBuilder').length > 0
            ? customQueryBuilder
            : defaultQueryBuilder;

        var searchUrl = 'search-results?' + rawSearchUrl;

        if (hfGlobalSearchSiteURL === undefined ||
            (hfGlobalSearchSiteURL !== undefined && hfGlobalSearchSiteURL === '')) {
            var hfSiteURL = $('#hfSiteURL');
            if (hfSiteURL.length) {
                searchUrl = '//' + hfSiteURL.val() + '/' + searchUrl; // + boostQueryParm; //new
            }
        } else {
            searchUrl = '//' + hfGlobalSearchSiteURL.val() + searchUrl; // + boostQueryParm; //new  
        }

        window.location.href = searchUrl;
    };
    var testKeypress = function (e, scopeToPass, inputToPass) {
        if (e.keyCode === 13) {
            e.preventDefault();
            testSearchInput(inputToPass, scopeToPass);
        }
    }; // END: testKeypress()

    function doSolrSearch(inquiry, searchScope) {
        queryText = encodeURIComponent(inquiry);

        //For Stats purposes, passing in JournalID consistently.
        //JournalIDs are expected even when none of the journals is selected.
        //Pass the extram parameter to handle Relevancy
        var q = '"' + queryText + '"';

        //Per TE-6432, removing v=$q from the boost query parameter
        //var boostQueryParm = "&exPrm_qqq={DEFAULT_BOOST_FUNCTION}" + q;
        var boostQueryParm = '' + q;
        var searchUrl = '';
        var hfSiteURL = '';
        if (hfGlobalSearchSiteURL === undefined ||
            (hfGlobalSearchSiteURL !== undefined && hfGlobalSearchSiteURL === '')) {
            hfSiteURL = $('#hfSiteURL');
        } else {
            hfSiteURL = hfGlobalSearchSiteURL;
        }
        if (searchScope === hfjournalSiteScope) { //Search is done across all journals.
            searchUrl = '/../journals/' + hfdefaultSearchURL + queryText + '&SearchSourceType=1';
        } else if (isNullOrEmpty(searchScope)) { //No Scope
            //for Stats purposes, we need to pass in all the journalIDs.
            //STATS:instead of passing in all the Journal IDs, just pass allJournals=1 in the querystring
            searchUrl = getSearchUrl({ baseUrl: hfdefaultSearchURL, queryText: queryText, searchSiteId: searchSiteID, passAllJournals: true });
            if (hfSiteURL.length) {
                searchUrl = '//' + hfSiteURL.val() + '/' + searchUrl;
            }
        } else if (searchScope === hfparentSiteScope) { //Parent Site
            searchUrl = '//' + hfParentSiteURL + '/' + getSearchUrl({ baseUrl: hfdefaultSearchURL, queryText: queryText, searchSiteId: hfparentSiteID });
        } else if (searchScope === hfIssueSiteScope) {  //In Issue Search
            searchUrl = getSearchUrl({ baseUrl: hfdefaultSearchURL, queryText: queryText, searchSiteId: searchSiteID, issueSearch: true });
            if (hfSiteURL.length) {
                searchUrl = '//' + hfSiteURL.val() + '/' + searchUrl;
            }
        } else if (searchScope === hfCurrentBookScope) {  //In Current Book
            let applyLatestEditionSearchFacet = '';
            if (hfIsLatestBookEdition.toLowerCase() === 'true') {
                applyLatestEditionSearchFacet = hfApplyLatestEditionSearchFacet.toLowerCase();
            }
            searchUrl = getSearchUrl({ baseUrl: hfdefaultSearchURL, queryText: queryText, searchSiteId: searchSiteID, currentBookSearch: true, applyLatestEditionSearchFacet: applyLatestEditionSearchFacet });
            if (hfSiteURL.length) {
                searchUrl = '//' + hfSiteURL.val() + '/' + searchUrl;
            }
        } else if (searchScope === hfBookSiteScope) { // Search is done across all books.
            searchUrl = '/../books/' + hfdefaultSearchURL + queryText + '&SearchSourceType=1';
        } else if (searchScope === hfUmbrellaScope) { // Umbrella.
            searchUrl = '//' + hfUmbrellaSiteUrl + '/' + getSearchUrl({ baseUrl: hfdefaultSearchURL, queryText: queryText, searchSiteId: hfUmbrellaSiteId });
        } else if (searchScope.startsWith(hfSeriesScope)) { //Series Taxonomy
            searchUrl = getSearchUrl({ baseUrl: hfdefaultSearchURL, queryText: queryText, searchSiteId: searchSiteID, series: currentSearchScope });
            if (hfSiteURL.length) {
                searchUrl = '//' + hfSiteURL.val() + '/' + searchUrl;
            }
        } else if (searchScope.startsWith(hfTaggedCollectionScope)) { //Tagged Collection
            searchUrl = getSearchUrl({ baseUrl: hfdefaultSearchURL, queryText: queryText, searchSiteId: searchSiteID, taggedCollection: currentSearchScope });
            if (hfSiteURL.length) {
                searchUrl = '//' + hfSiteURL.val() + '/' + searchUrl;
            }
        }
        else if (searchAcrossOA) { //Oxford Taxonomy umbrella search
            searchUrl = getSearchUrl({ baseUrl: hfdefaultSearchURL, queryText: queryText, searchSiteId: hfUmbrellaSiteId, taxonomy: searchScope });
            if (hfSiteURL.length) {
                searchUrl = '//' + hfUmbrellaSiteUrl + '/' + searchUrl; // + boostQueryParm; //new
            }
        } else { //Taxonomy 
            searchUrl = getSearchUrl({ baseUrl: hfdefaultSearchURL, queryText: queryText, searchSiteId: searchSiteID, taxonomy: searchScope });
            if (hfSiteURL.length) {
                searchUrl = '//' + hfSiteURL.val() + '/' + searchUrl; // + boostQueryParm; //new
            }
        }
        
        if (searchScope === '') {
            searchUrl = applyLatestEditionSearchFacet(searchUrl, hfSiteURL);
        }
        
        if (searchUrl !== '') {
            searchUrl = updateUrlForProxy(searchUrl);
            window.location.href = searchUrl;
        }
        
    } // END: doSolrSearch(inquiry, searchScope)
    
    function applyLatestEditionSearchFacet(searchUrl, hfSiteURL) {
        if (hfApplyLatestEditionSearchFacet.toLowerCase() !== 'true') {
            return searchUrl;
        }
        
        searchUrl = getSearchUrl({baseUrl: hfdefaultSearchURL, queryText: queryText, searchSiteId: searchSiteID, applyLatestEditionSearchFacet: hfApplyLatestEditionSearchFacet.toLowerCase()});
        if (hfSiteURL.length) {
            searchUrl = '//' + hfSiteURL.val() + '/' + searchUrl;
        }
        
        return searchUrl;
    }

    function updateUrlForProxy(searchUrl) {
        var currentHost = window.location.host;
        if (searchUrl.startsWith('//')) {
            searchUrl = window.location.protocol + searchUrl;
        }
        else if (searchUrl.startsWith('/')) {
            return searchUrl;  // don't need to update a relative url
        }
        var url = new URL(searchUrl);
        var urlHost = url.host;
        if (currentHost !== urlHost) {
            searchUrl = searchUrl.replace(urlHost, currentHost);
        }
        return searchUrl;
    }

    function getSearchUrl(params) /* -> string */ {
        
        var searchUrl = params.baseUrl;
        if (!searchUrl) {
            searchUrl = '';
        }
        if (params.queryText) {
            searchUrl += params.queryText;
        } else {
            searchUrl = searchUrl.replace('&q=', '');
        }
        if (params.searchSiteId) {
            searchUrl += '&fl_SiteID=' + params.searchSiteId;
        }
        searchUrl += '&SearchSourceType=1';
        if (params.passAllJournals) {
            searchUrl += '&allJournals=1';
        }
        if (params.issueSearch) {
            if (hfIssueSearch) {
                searchUrl += hfIssueSearch;
            }
        }
        if (params.currentBookSearch) {
            if (hfCurrentBookSearch) {
                searchUrl += hfCurrentBookSearch;
            }
        }
        if (params.series) {
            searchUrl += '&' + params.series;
        }
        if (params.taxonomy) {
            searchUrl += '&' + getTaxonomyParameter(params.taxonomy);
        }
        if (params.taggedCollection) {
            searchUrl += '&' + params.taggedCollection;
        }
        if (params.applyLatestEditionSearchFacet === 'true') {
            searchUrl += '&LatestEditionOnly=true';
        }
        return searchUrl;
    }

    function isNullOrEmpty(element) {
        return typeof element === 'undefined' || element === undefined || element === null || element === '';
    }

    function getTaxonomyParameter(/*string*/ taxonomy) /* -> string */ {
        return 'tax=' + taxonomy;
    }

    var openSaveSolrSearch = function (solrSearchSaveModel) {
        solrSearchSaveModel.foundation('reveal', 'open');
    };

    var saveSolrSearchInfo = function (solrSearchSaveModel) {
        var txtSolrSearchName = $(solrSearchSaveModel.find('.txtSolrSearchName'));
        var ddlSearchAlertFrequency = $(solrSearchSaveModel.find('#ddlSearchAlertFrequency'));

        if ($.trim(txtSolrSearchName.val()) === '' || txtSolrSearchName.val() === null) {
            alert('Please enter a name');
            return false;
        }

        var redirectUrl = $('#hdnSearchSaveRedirectUrl');
        var currentUrl = window.location.href;

        var token = $('#SolrSearchAuthToken').val();
        var data = JSON.stringify({
            searchName: txtSolrSearchName.val(),
            url: currentUrl,
            scheduleId: ddlSearchAlertFrequency.val(),
            redirectUrl: redirectUrl.val(),
            token: token
        });
        var ajaxUrl = '//' + SCM.SearchResults.defaults.baseSiteUrl + '/Solr/SaveSolrSearchInfoWithToken';

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'json',
            cache: false, // to defeat browser URL caching
            data: data,
            contentType: 'application/json; charset=utf-8',
            success: function (result) {
                if (result !== null) {
                    if (result.ReturnId) {
                        $('#SolrSearchAuthToken').val(result.ReturnId);
                    }

                    if (result.RedirectUrl && result.RedirectUrl.length) {
                        window.location = result.RedirectUrl;
                    } else {
                        alert(result.Html);
                        solrSearchSaveModel.foundation('reveal', 'close');
                    }
                }
            },
            error: function (xmlHttpRequest, textStatus, errorThrown) {
                if (window.console) {
                    var err = eval('(' + xmlHttpRequest.responseText + ')');
                    console.log('error: ' + err);
                    console.log('status: ' + textStatus);
                }
            }
        });
    };

    function buildSaveSearchUiEvent() {
        var lnkSaveSolrSearch = $('.lnkSaveSolrSearch'),
            solrSearchSaveModel = $('.solrSearchSaveModel'),
            btnSolrSearchSave = $('.btnSolrSearchSave'),
            txtSolrSearchName = $('.txtSolrSearchName');

        // save solr search. Unbind event before register click event to prevent multiple clicks.
        lnkSaveSolrSearch.off('click').on('click', function () {
            var isUserLoggedIn = $(this).attr('data-userloggedin');
            if (isUserLoggedIn !== undefined && isUserLoggedIn.toLowerCase() === 'false') {
                var redirectUrl = $('#hdnSearchSaveRedirectUrl');
                var currentUrl = window.location.href;
                window.location = redirectUrl.val() + '?returnUrl=' + encodeURIComponent(currentUrl + '#triggerSaveSearch=1');
            } else {
                openSaveSolrSearch(solrSearchSaveModel);
            }
        });
        btnSolrSearchSave.off('click').on('click', function () { saveSolrSearchInfo($(this).parents('.solrSearchSaveModel')); });
        txtSolrSearchName.off('keypress')
            .on('keypress',
                function (e) {
                    var code = e.keyCode || e.which;
                    if (code === 13) {
                        saveSolrSearchInfo($(this).parents('.solrSearchSaveModel'));
                    }
                });
    }

    function restrictedImagesSearch() {
        $('div.sri-figure[restricted]')
            .each(function () {
                $(this).off('contextmenu').on('contextmenu', function () { return false; });
            });
    }

    //------------------TAXONOMY------------------------------
    //TaxonomyBrowse
    $(document).on('click', '.js-taxonomy-label:not(.js-taxonomy-checkbox):not(.checkbox-label)', taxonomyItemClick);
    $(document).on('click', '.js-taxonomy-checkbox', taxonomyItemClick);

    function taxonomyItemClick(e) {
        var $el = $(this);
        if ($el.closest('.alert-resource-list-wrapper').length) {
            App.TaxonomyFacet.updateTaxonomyTreeModal($el);
            return;
        }
        var currentDataUrl = App.TaxonomyFacet.getTaxonomyUrl($el);
        SCM.SearchResults.doSolrSearch({ queryString: currentDataUrl });
    }

    function bindUiEvents() {
        var micrositeSearchIcon = $('.js-master-header').find('.microsite-search-icon'),
            micrositeSearchTerm = $('.js-master-header').find('.microsite-search-term'),
            mobileMicrositeSearchIcon = $('.js-master-header').find('.mobile-microsite-search-icon'),
            mobileMicrositeSearchTerm = $('.js-master-header').find('.mobile-microsite-search-term'),
            bookQuickSearchSearchIcon = $('.js-book-search-icon'),
            bookQuickSearchSearchTerm = $('.js-book-search-term'),
            umbrellaSearchIcon = $('#UmbrellaSearchIcon'), // icon
            umbrellaHomeSearchIcon = $('#UmbrellaHomeSearchIcon'), // home icon
            umbrellaSearchTerm = $('#UmbrellaSearchTerm'), // term 
            umbrellaHomeSearchTerm = $('#UmbrellaHomeSearchTerm'), // home term
            articleKeywordSearchTerm = $('.kwd-part'), // article page keyword term
            articleTopicSearchTerm = $('.js-qb-topic-keyword-search'), // article page keyword term
            umbrellaScope = 'J*'; // J* = all journals (umbrella search) 

        // Searches performed when a search icon is clicked
        umbrellaSearchIcon
            .on('click', function () { testSearchInput(umbrellaSearchTerm.val(), umbrellaScope); });
        umbrellaHomeSearchIcon.on('click',
            function () { testSearchInput(umbrellaHomeSearchTerm.val(), umbrellaScope); });
        micrositeSearchIcon.on('click',
            function () { testSearchInput(micrositeSearchTerm.val(), currentSearchScope); });
        mobileMicrositeSearchIcon.on('click',
            function () { testSearchInput(mobileMicrositeSearchTerm.val(), currentSearchScope); });
        bookQuickSearchSearchIcon.on('click',
            function () { testSearchInput(bookQuickSearchSearchTerm.val(), hfCurrentBookScope); });
        $(document.body).on('click', '.toolbar-search .microsite-search-icon',
            function () { testSearchInput($(this).siblings('.microsite-search-term').val(), currentSearchScope); });

        $('.searchLi .icon-search')
            .on('click', function () { testSearchInput(micrositeSearchTerm.val(), currentSearchScope); });
        articleKeywordSearchTerm.on('click', function () { doKeywordsTopicsSearch($(this).data('keyword')); });
        articleTopicSearchTerm.on('click', function () { doKeywordsTopicsSearch($(this).data('topic')); });

        // Searches performed when 'Enter' is pressed
        umbrellaSearchTerm.on('keypress',
            function (e) { testKeypress(e, umbrellaScope, umbrellaSearchTerm.val()); });
        umbrellaHomeSearchTerm.on('keypress',
            function (e) { testKeypress(e, umbrellaScope, umbrellaHomeSearchTerm.val()); });
        micrositeSearchTerm.on('keypress',
            function (e) { testKeypress(e, currentSearchScope, micrositeSearchTerm.val()); });
        mobileMicrositeSearchTerm.on('keypress',
            function (e) { testKeypress(e, currentSearchScope, mobileMicrositeSearchTerm.val()); });
        bookQuickSearchSearchTerm.on('keypress',
            function (e) { testKeypress(e, hfCurrentBookScope, bookQuickSearchSearchTerm.val()); });
        $(document.body).on('keypress', '.toolbar-search .microsite-search-term',
            function (e) { testKeypress(e, currentSearchScope, $(this).val()); });

    } // END: bindUiEvents


    // ----
    // public methods and properties accessible by SCM.[module_name].[method_name]
    // ----
    SolrSearch.init = function () {

        // If view is ViewLarge this function will break MathJax, therefore we will not execute this on ViewLarge
        if (SCM.SiteJS.isPageViewLarge()) {
            return;
        }

        var searchScope = '';
        //$sortDropdown = $('.sort-dropdown'),
        //$sortOption = $('.sort-dropdown-option');

        bindUiEvents();
        buildSaveSearchUiEvent();
        restrictedImagesSearch();

        setAdvancedSearchLinkToCurrentSearchScope();

        // Mobile Search Filters
        bodyVar.on('click', '.sf-group-header', function () {
            //Search filters are only collapsible on mobile/table viewports
            if ($(window).outerWidth() < 1024) {
                var $this = $(this);
                var $facetHeaderIcon = $this.children('.sf-group-header-icon');
                var $facetList = $this.siblings('fieldset').find('.sf-facets, .sf-facet-list, .js-facet-filter-box');
                $facetList.slideToggle();
                $this.siblings('.taxonomy-child-list').slideToggle();
                $facetHeaderIcon.hasClass('icon-general_arrow-right')
                    ? $facetHeaderIcon.removeClass('icon-general_arrow-right')
                        .addClass('icon-general_arrow-down')
                    : $facetHeaderIcon
                        .removeClass('icon-general_arrow-down')
                        .addClass('icon-general_arrow-right');
                $this.siblings('.js-facet-filter-box').slideToggle();
            }
        });

        // configure Query Builder on page load
        SCM.QueryBuilder.configure();

        if ($(SCM.SearchResults.defaults.updateTargetSelector).length > 0) {
            //we're on the search results page so all searches should call the search results search method
            SCM.QueryBuilder.defaults.runSearch = function (queryString) {
                SCM.SearchResults.doSolrSearch({ queryString: queryString });
            };
        } else {

            //configure querybuilder for advance search
            $('.querybuilder-submit').attr('value', 'Search');
            $('.querybuilder-title').text('Build a query');

            SCM.QueryBuilder.defaults.runSearch = function (redirectUrl) {
                var searchSiteUrl = $('#hfSiteURL').val();
                if (redirectUrl.indexOf('q=') === -1) {
                    redirectUrl = 'q=' + redirectUrl;
                }
                window.location = window.location
                    .protocol +
                    '//' +
                    searchSiteUrl +
                    '/search-results?' +
                    redirectUrl;
            };
        }

        // give initial sort order selection a class of 'selected'
        $('.sort-dropdown-option:selected').addClass('selected');


        bodyVar.on('click',
            '.sriTopiclink',
            function (e) {
                queryText = $(this).text();
                var searchTerm = queryText.replace(',', ''); // if string ends with coma remove it.
                searchScope = currentSearchScope; // hfSolrJournalID.val();
                if (searchScope === '' || searchScope === null) {
                    doSolrSearch(searchTerm, null);
                } else {
                    doSolrSearch(searchTerm, searchScope);
                }
                e.preventDefault();
            }); // END: $body.on('click', '.sriTopiclink', function (e) {})

        //CollectionLink Click (collections.aspx)
        $('a.categoryLink').each(function () {
                var _href = $(this).attr('href');
                var journalId = hfSolrJournalID.val();
                if (isNullOrEmpty(journalId)) {
                    $(this).attr('href', hfGlobalSearchSiteURL + _href);
                } else {
                    //microsite
                    var journalIdParm = journalId.substr(1, journalId.length);
                    $(this).attr('href', '/' + _href + '&fd_JournalID=' + journalIdParm);
                }
            }); // END: $.each("a.categoryLink", function () {})


        bodyVar.on('click',
            '#topicResultsWire',
            function (e) {
                var query = location.search;
                //journalId needs to be removed from query -- it's the last param
                query = query.substring(0, query.indexOf('&fd_JournalID'));
                window.location.href = hfGlobalSearchSiteURL.val() + 'solr/topicresults.aspx' + query;
            }); // END: $body.on('click', '#topicResultsWire', function (e) {})

        bodyVar.on('click',
            '.mg-tab',
            function (e) {
                var tabName = $(this).data('tab');
                /* When transitioning between tabs, clear all parameters except free search, siteId, searchSourceType and allJournals elements if present */
                var freeSearchValue = SCM.JSUtility.getSearchParamByName('q');
                var freeSearchQueryElement = '';
                if (freeSearchValue) {
                    freeSearchQueryElement = '&q=' + freeSearchValue;
                }
                var queryBuilderValue = SCM.JSUtility.getSearchParamByName('qb');
                var queryBuilderElement = '';
                if (queryBuilderValue) {
                    queryBuilderElement = '&qb=' + queryBuilderValue;
                }
                var customQueryBuilderValue = SCM.JSUtility.getSearchParamByName('cqb');
                var customQueryBuilderElement = '';
                if (customQueryBuilderValue) {
                    customQueryBuilderElement = '&cqb=' + customQueryBuilderValue;
                }
                var siteIdElement = '';
                var siteIdValue = SCM.JSUtility.getSearchParamByName('fl_SiteID');
                if (siteIdValue) {
                    siteIdElement = '&fl_SiteID=' + siteIdValue;
                }
                var searchSourceTypeElement = '';
                var searchSourceTypeValue = SCM.JSUtility.getSearchParamByName('SearchSourceType');
                if (searchSourceTypeValue) {
                    searchSourceTypeElement = '&SearchSourceType=' + searchSourceTypeValue;
                }
                var allJournalsElement = '';
                var allJournalsValue = SCM.JSUtility.getSearchParamByName('allJournals');
                if (allJournalsValue) {
                    allJournalsElement = '&allJournals=' + allJournalsValue;
                }
                var imageQueryStringValue = SCM.JSUtility.getSearchParamByName('mg');
                var imageTabActive = false;
                if (imageQueryStringValue) {
                    imageTabActive = (imageQueryStringValue.toLowerCase() === 'true');
                }

                var articleDateQueryStringElement = '';
                var articleDateQueryStringValue = SCM.JSUtility.getSearchParamByName('rg_ArticleDate');
                if (articleDateQueryStringValue) {
                    articleDateQueryStringElement = '&rg_ArticleDate=' + articleDateQueryStringValue;
                }

                var articleDateFilterTypeElement = '';
                var articleDateFilterTypeValue = SCM.JSUtility.getSearchParamByName('dateFilterType');
                if (articleDateFilterTypeValue) {
                    articleDateFilterTypeElement = '&dateFilterType=' + articleDateFilterTypeValue;
                }

                var baseUrl = window.location.href.split('?')[0];
                var fullUrl = baseUrl + '?page=1' + freeSearchQueryElement + siteIdElement +
                              searchSourceTypeElement + allJournalsElement + articleDateQueryStringElement +
                              articleDateFilterTypeElement + customQueryBuilderElement + queryBuilderElement;
                if (tabName === 'Images' && !imageTabActive) {
                    window.location.href = fullUrl + '&mg=true';
                }
                else if (tabName === 'AllResults' && imageTabActive) {
                    window.location.href = fullUrl;
                }
            }); // END: $body.on('click', '.mg-tab', function (e) {})

    }; // END: SolrSearch.init()

    /// Refresh Brightcove videos in search results.
    /// NOTES:
    /// * This is ONLY intended to be used after running a search in ajaxComplete() below.
    ///   See SCM.Utilities.Brightcove for most use cases.
    /// * To minimize repeated attempts to re-initialize, we only initialize videos when at least one 
    ///   Brightcove video can be found in the search results and 
    ///     * the first video is not initialized yet.
    ///     * OR Brightcove functionality isn't loaded yet.
    SolrSearch.RefreshBrightcove = function () {
        if ($('#searchResultsPage .brightcove-player').length) {

            // If videojs isn't initialized, then brightcove isn't.
            // At the risk of initializing more than once (if already pending),
            // we'll just call the code to initialize Brightcove.
            // This detects videos to load for us so we can return after calling this.
            if (typeof (videojs) === 'undefined') {
                SCM.Utilities.Brightcove.init();
                return;
            }

            // find first video in search results list
            var first = $('#searchResultsPage .brightcove-player')[0];

            // fetch without initializing
            //   see https://docs.brightcove.com/brightcove-player/current-release/module-videojs-videojs.html
            var player = videojs.getPlayer(first);

            // don't initialize any players if at least one is already initialized
            if (!player) {
                SCM.Utilities.Brightcove.init(); // OUP-specific
            }

        }
    };

    SolrSearch.ajaxComplete = function () {
        buildSaveSearchUiEvent();
        restrictedImagesSearch();
        SCM.QueryBuilder.configure();
        SCM.SiteJS.initSearchResultsSort();
        SCM.PublicationDateFilter.init();
        SCM.CollectionFacet.toggleCollectionParent();
        SCM.BookPartTitleFacet.toggleBookPartTitleParent();
        SCM.CustomQueryBuilder.init();

        // NARN-16871 - re-initialize brightcove after search page is loaded
        SolrSearch.RefreshBrightcove();
        
        // NARN-16772: Re-install mobile left column events.
        //             Note: There's a bug in the code where events can keep getting registered at top level.
        //                   We can't prevent it without refactoring the code.  We can try to call only when we have to, however.
        if ($('.page-column--left').not('[data-client-solrsearch-event-registered]').length) {
            SCM.SiteJS.toggleResponsiveLeftColumn();
            $('.page-column--left').attr('data-client-solrsearch-event-registered', 'true');
        }
        if (bodyVar.hasClass('pg_SearchResults')) {
            SCM.LazyLoadAd.loadAds();
        }
    };
        
    if ($('#hfNbnjToc').val()) {
        SCM.SearchResults.defaults
            .updateTargetSelector = '#ContentTab';
        SCM.SearchResults.defaults
            .isNbnj = true;
        SCM.SearchResults.defaults
            .controller = "Page";
        SCM.SearchResults.defaults
            .action = "NbnjBookSearch";
        SCM.SearchResults.defaults
            .instanceName = "Nbnj_BookToc";
    }
    else {
        SCM.SearchResults.defaults.instanceName = 'OUP_SearchResults';
        SCM.SearchResults.defaults
            .updateTargetSelector = '#searchResultsPage'; // overwrite default value of '#divSearch'
    }

    var baseSiteURL = $('#hfSiteURL');

    if (typeof baseSiteURL !== 'undefined' && baseSiteURL.val() !== '') {
        SCM.SearchResults.defaults.baseSiteUrl = baseSiteURL.val();
    }

    SCM.SolrSearch.init();

})(SCM.SolrSearch = SCM.SolrSearch || {}, jQuery);

